import {
    stringToHTML,
    createQuestion,
    createOption,
    updateQuestion,
    updateOption,
    generateUUID,
    createQuestionTemplateStep,
} from "../helper";
import * as consts from "../const";
import tippy from "tippy.js";
import Vue from "vue";
import AppEditor from "~/components/AppEditor";
Vue.config.productionTip = false;

export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const SM = editor.StorageManager;
    const COMMANDS = editor.Commands;
    const MD = editor.Modal;
    const TYPE = DOMC.getType("default");
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    var model = MODEL.extend(
        {
            defaults: {
                ...MODEL.prototype.defaults,
                tagName: "div",
                droppable: false,
                draggable: "form, form *",
                attributes: {
                    class: "form-group",
                    name: "options",
                    "data-uuid": "",
                    "c-type": "c-options",
                },
                style: {
                    padding: "0.5em",
                },
                components: [
                    {
                        type: "C-QUESTION-TEXT",
                    },
                    {
                        type: "row",
                    },
                ],
                question: "What is your question?",
                options: [],
                format: "select",
                visible_condition: true,
                questionId: null,
                templateStepId: null,
                questionTemplateStep: null,
            },
            init() {
                let options = this.get("options");
                if (options.length == 0) {
                    this.set("options", [
                        {
                            key: generateUUID(),
                            label: "Option 1",
                            value: null,
                        },
                        {
                            key: generateUUID(),
                            label: "Option 2",
                            value: null,
                        },
                    ]);
                }
            },
        },
        {
            isComponent(el) {
                if (
                    el &&
                    el.attributes &&
                    el.attributes["c-type"] &&
                    el.attributes["c-type"] == "c-options"
                ) {
                    return { type: "C-OPTIONS" };
                }
            },
        }
    );

    var view = VIEW.extend({
        init: function () {
            let model = this.model;
            // this.listenTo(model, 'change:attributes change:format', this.updateComponent);
            this.listenTo(model, "change:format", this.changeFormat);
        },
        /**
         * Trigger when the render is completed
         */
        onRender() {
            this.updateComponent();
            this.createCustomMenu();
            this.watchQuestionText();
            this.watcherOptionLabel();
        },

        updateComponent: async function () {
            const id = this.model.getId();
            if (!id) {
                return;
            }
            // Render the question
            await this.registerQuestion();

            // Control the current format component.
            this.controlFormat();

            // Render the options
            let options = this.model.get("options");
            let component_options = this.model.components().at(1);
            component_options.view.cleanOptions(options);

            for (let op of options) {
                op = await this.registerOption(op);
                component_options.view.renderOption(op);
            }
            this.model.set("options", options);

            await this.registerQuestionByStep();
        },
        changeFormat: function () {
            this.controlFormat();

            const options = this.model.get("options");
            const component_options = this.model.components().at(1);
            // Control the current format component.

            for (let op of options) {
                component_options.view.renderOption(op);
            }
            this.model.set("options", options);
        },
        watchQuestionText() {
            let component_question_text = this.getComponentQuestionText();
            component_question_text.listenTo(
                component_question_text,
                "change",
                (model) => {
                    if (this.model.get("question") != this.getQuestionText()) {
                        this.model.set("question", this.getQuestionText());
                        this.registerQuestion();
                        editor.store();
                    }
                }
            );
        },
        watcherOptionLabel() {
            let component_options = this.getComponentQuestionOptions();
            let options_labels = component_options.findType("label");
            let options = this.model.get("options");
            for (let i = 0; i < options_labels.length; i++) {
                const label = options_labels[i];
                let option = options[i];
                label.listenTo(label, "change", (model) => {
                    const text_label = label.components().at(0).get("content");
                    if (text_label != option.label) {
                        option.label = text_label;
                        this.registerOption(option);
                        editor.store();
                    }
                });
            }
        },
        getQuestionText() {
            let label = this.model.components().at(0);
            return label.getContent();
        },
        setQuestionText(content) {
            let label = this.model.components().at(0);
            label.setContent(content);
            return content;
        },
        /**
         * @function controlFormat
         * @description It controls the current format of the component and if there is any change it initializes it.
         * @returns true or false if there is any change.
         */
        controlFormat: function () {
            const format = this.model.get("format");
            const attributes = this.model.get("attributes");
            let changed = false;
            let componentOptions = this.model.components().at(1);
            let type = componentOptions.attributes.type;

            if (
                format == "select" &&
                (type == "C-RADIO-GROUP" || type != "C-SELECT-OPTIONS")
            ) {
                this.model.append({
                    type: "C-SELECT-OPTIONS",
                    questionUUID: attributes["data-uuid"],
                });
                changed = true;
            }
            if (
                format == "radio" &&
                (type == "C-SELECT-OPTIONS" || type != "C-RADIO-GROUP")
            ) {
                this.model.append({
                    type: "C-RADIO-GROUP",
                    questionUUID: attributes["data-uuid"],
                });
                changed = true;
            }
            if (changed) this.model.components().at(1).remove();
            return changed;
        },
        /**
         * @function registerQuestion
         * @description If the question does not have UUID it will be registered, if it has UUI it will update the question
         */
        registerQuestion: async function () {
            const storageManagerSteps = sm.get(opts.storage_name);
            const storageStepsActive = storageManagerSteps.isActive();
            const currentStep = storageManagerSteps.current_step;

            let title = this.getQuestionText();
            let questionId = this.model.get("questionId");
            let templateStepId = this.model.get("templateStepId");
            if (
                (questionId && !storageStepsActive) ||
                (questionId &&
                    storageStepsActive &&
                    currentStep == templateStepId)
            ) {
                await updateQuestion(title, questionId);
                return;
            }
            questionId = await createQuestion(title);
            this.model.set("questionId", questionId);

            var _attr = this.model.get("attributes");
            _attr["data-uuid"] = questionId;
            this.model.setAttributes(_attr);
        },
        /**
         * @function registerQuestionByStep
         */
        registerQuestionByStep: async function () {
            const storageManagerSteps = sm.get(opts.storage_name);
            const storageStepsActive = storageManagerSteps.isActive();
            const stepId = storageManagerSteps.current_step;
            const questionTemplateStep = this.model.get("questionTemplateStep");
            const templateStepId = this.model.get("templateStepId");
            const questionId = this.model.get("questionId");

            if (!storageStepsActive) {
                console.error("Storage step is disable!");
                return;
            }
            if (
                storageStepsActive &&
                questionTemplateStep &&
                templateStepId == stepId
            ) {
                console.log("Existing relationship");
                return;
            }

            const { insertId } = await createQuestionTemplateStep(
                questionId,
                stepId
            );
            this.model.set("questionTemplateStep", insertId);
            this.model.set("templateStepId", stepId);
            editor.store();
        },
        /**
         * @function registerOption
         * @param {Object} option Object option wiht params key,label,value
         * @description  If the option does not have UUID it will be registered, if it has UUID it will update the option.
         * @returns Option object with updated parameters
         */
        registerOption: async function (option) {
            const storage_manager_steps = sm.get(opts.storage_name);
            const storage_steps_active = storage_manager_steps.isActive();
            const current_step = storage_manager_steps.current_step;

            let template_step_id = this.model.get("templateStepId");
            let question_id = this.model.get("attributes")["data-uuid"];
            let resp = option;

            /* console.log("Storage active",storage_steps_active);
            console.log("Current step",current_step);
            console.log("Step id",template_step_id);
            console.log("Option value",option.value) */
            if (
                (option.value && !storage_steps_active) ||
                (option.value &&
                    storage_steps_active &&
                    current_step == template_step_id)
            ) {
                // console.log("The option already has value!");
                let changed = await updateOption(option.label, option.value);
                if (changed == 1) {
                    //   console.log("Option update!");
                } else {
                    //   console.log("The option has no changes!");
                }
                return resp;
            }

            resp.value = await createOption(option.label, question_id);
            return resp;
        },
        /**
         * @function createCustomMenu
         * @description Create a custom tooltip menu in the editor view.
         */
        createCustomMenu: function () {
            let el = this.el;
            var self = this;
            var component = this.model;
            let wrapperEl = editor.getWrapper().view.el;
            let tooltip =
                /*html*/
                `
            <style>
                
                .list-toggle{
                    display: flex;
                    list-style: none;
                    padding: 0;
                    margin:0;
                }
                .list-toggle .item{
                    margin: 0 0.3rem;
                    padding: 0 0.5rem;
                }
                .dropdown-menu{
                    background: transparent;
                    border: none;
                    min-width: 14rem;
                    display:flex;
                }
            </style>
            <div id="template">
                <ul class="list-toggle">
                    <li class="item add dropdown">
                        <div class="dropdown-toggle" id="addDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="far fa-plus-square"></i>
                        </div>
                        <div class="dropdown-menu" style="height:0px;" aria-labelledby="addDropdown">
                            <div class="input-group" style="display:none;">
                                <input type="text" value="Option" class="form-control" data-status="create" placeholder="Add an option" aria-label="Option">
                                <div class="input-group-append" aria-label="btnSave">
                                    <span class="input-group-text"><i class="fas fa-plus"></i></span>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="item exchange">
                        <i class="fas fa-sync"></i>
                    </li>
                    <li class="item config" data-toggle="modal" data-target="#staticBackdrop">
                        <i class="fas fa-cog fa-1x"></i>
                    </li>
                </ul>
            </div>
            `;

            const instance = tippy(el, {
                content: tooltip,
                allowHTML: true,
                trigger: "click",
                theme: "light",
                interactive: true,
                zIndex: 100,
                arrow: true,
                onCreate(instance) {
                    let itemConfig =
                        instance.popper.querySelector(".item.config");
                    itemConfig.addEventListener("click", (e) => {
                        e.preventDefault();
                        editor.runCommand("open-modal-options", { component });
                        instance.hide();
                    });

                    let item_exchange =
                        instance.popper.querySelector(".item.exchange");
                    item_exchange.addEventListener("click", (e) => {
                        e.preventDefault();
                        editor.runCommand("exchange-shape-options", {
                            component,
                        });
                        instance.hide();
                    });

                    let addDropdown =
                        instance.popper.querySelector("#addDropdown");
                    let dropdownMenu = instance.popper.querySelector(
                        ".dropdown-menu[aria-labelledby=addDropdown]"
                    );
                    let inputGroup = dropdownMenu.querySelector(".input-group");
                    wrapperEl.addEventListener("click", function (e) {
                        if (
                            dropdownMenu.contains(e.target) ||
                            (addDropdown.contains(e.target) &&
                                dropdownMenu.style.height == "0px")
                        ) {
                            dropdownMenu.style.height = "20px";
                            inputGroup.style.display = "flex";
                        } else {
                            dropdownMenu.style.height = "0px";
                            inputGroup.style.display = "none";
                        }
                    });

                    let itemAdd = instance.popper.querySelector(
                        ".list-toggle [aria-label=btnSave]"
                    );
                    itemAdd.addEventListener("click", async (e) => {
                        e.preventDefault();
                        let inputAddOption = instance.popper.querySelector(
                            ".list-toggle input[aria-label=Option]"
                        );

                        let option = {
                            key: generateUUID(),
                            label: inputAddOption.value,
                            value: null,
                        };
                        option = await self.registerOption(option);
                        let options = self.model.get("options");
                        options.push(option);
                        self.model.set("options", options);
                        self.model.components().at(1).view.renderOption(option);
                        instance.hide();
                    });
                },
            });
        },
        getComponentQuestionText: function () {
            let label = this.model.components().at(0);
            return label;
        },
        getComponentQuestionOptions: function () {
            return this.model.components().at(1);
        },
    });

    DOMC.addType("C-OPTIONS", {
        model,
        view,
    });

    COMMANDS.add("open-modal-options", {
        run: function (editor, sender, params) {
            let component = params.component;
            let options = component.get("options");
            let question_text = component.view.getQuestionText();
            let format = component.get("format");
            let name = component.get("attributes")["name"];
            let id = component.getId();

            let container = document.createElement("div");
            container.setAttribute("id", "vue-app");

            MD.setTitle("Component settings").setContent(container).open();

            new Vue({
                ...AppEditor,
                element: "ModalOptions",
                editor,
                opts,
                payload: {
                    component,
                    question_text,
                    options,
                    format,
                    attributes: {
                        name,
                        id,
                    },
                },
            }).$mount("#vue-app");
        },
    });
    COMMANDS.add("update-model-options", {
        run: function (editor, sender, params) {
            let component = params.component;
            let options = params.options;
            let format = params.format;
            let question_text = params.question_text;
            let name = params.name;
            let id = params.id;
            let required = params.required;
            component.set({
                options,
                format,
                required,
                attributes: {
                    ...component.get("attributes"),
                    name,
                    id,
                },
            });
            component.view.setQuestionText(question_text);
            component.view.updateComponent();
        },
    });

    COMMANDS.add("exchange-shape-options", {
        run: function (editor, sender, params) {
            const component = params.component;
            const format = component.get("format");
            if (format == consts.options_format.format_1) {
                component.set("format", consts.options_format.format_2);
            } else {
                component.set("format", consts.options_format.format_1);
            }
        },
    });
};
